import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

export const searchImsiForImport = async (token, search) => {
  log("welcome in searchImsiForImport")

  if (!token || token === "") {
    return { error: true, message: "No token provided", imsis: [] }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/search_imsi_for_veridian_import_api?search=' + encodeURIComponent(search)

    const result = await axios.get(url, { headers })
    log("result.data from searchImsiForImport")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in searchImsiForImport")
    log(err)
    error.value = err.message
    return { error: true, message: "Error searching IMSI", imsis: [] }
  }
}

export const importImsisFromVeridian = async (token, imsiSerials) => {
  log("welcome in importImsisFromVeridian")

  if (!token || token === "") {
    return { error: true, message: "No token provided", results: [] }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/import_imsis_from_veridian_api'

    const result = await axios.post(url, { imsi_serials: imsiSerials }, { headers })
    log("result.data from importImsisFromVeridian")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in importImsisFromVeridian")
    log(err)
    error.value = err.message
    return { error: true, message: "Error importing IMSIs", results: [] }
  }
}

const useVeridianImportAPI = () => {
  return { error, searchImsiForImport, importImsisFromVeridian }
}

export default useVeridianImportAPI
